import React from "react";
import { useSelector } from "react-redux";
import {
    Badge,
    Chip,
    List,
    ListItem,
    ListItemText,
    Tooltip,
    Typography
} from "@mui/material/";
import SubjectSharpIcon from "@mui/icons-material/SubjectSharp";
import { format } from "../../../../common/lib";
import { strings } from "../../../../common/i18n";
import { getAuditFilterChips } from "../../../auditFilterUtils";
import styles from "./styles";

/**
 * Audit details Component
 */

export default () => {
    const { auditsList, typesList } = useSelector((state) => state);
    const { item } = auditsList;
    const filterChips = getAuditFilterChips(item?.filter, typesList);

    const generateListItem = (label, value) => (
        <ListItem sx={styles.listItem}>
            <ListItemText
                primary={<Typography variant="caption">{label}</Typography>}
            />
            <Typography variant="caption">
                {format.displayDatesWithTime(value)}
            </Typography>
        </ListItem>
    );

    return (
        <>
            <Badge color="primary">
                <SubjectSharpIcon color="primary" />
                <Typography variant="body1" sx={{ ml: 1 }}>
                    {strings("auditDetails")}
                </Typography>
            </Badge>

            <List>
                {generateListItem(strings("created"), item?.createdDate)}
                {generateListItem(strings("start"), item?.startDate)}
                {generateListItem(strings("due"), item?.endDate)}
                {filterChips.map((chip, index) => (
                    <ListItem key={chip.key} sx={{ ...styles.listItem, maxHeight: "28px" }}>
                        <ListItemText
                            primary={
                                <Typography variant="caption">
                                    {index === 0 ? strings("filters") : ""}
                                </Typography>
                            }
                        />
                        <Tooltip title={chip.tooltip ?? ""} disableHoverListener={!chip.tooltip}>
                            <Chip
                                label={chip.label}
                                size="small"
                                variant="outlined"
                                sx={{ fontSize: "0.65rem", height: "20px", pointerEvents: chip.tooltip ? "auto" : "none", cursor: "default" }}
                            />
                        </Tooltip>
                    </ListItem>
                ))}
            </List>
        </>
    );
};
